<div class="vacation-request-container p-fluid">
  <div class="row">
    <div class="column">
      <h2 class="title">Especifica el periodo</h2>

      <!-- Tipo de Vacaciones -->
      <div class="p-field-autocomplete">
        <label for="vacationType">Tipo de vacaciones</label>
        <p-autoComplete
          id="vacationType"
          [(ngModel)]="selectedVacationType"
          [suggestions]="filteredVacationTypes"
          (completeMethod)="filterVacationTypes($event)"
          (input)="onChangeInput($event)"
          [dropdown]="true"
          [forceSelection]="true"
          placeholder="Seleccione el tipo"
          (onSelect)="onSelect($event)"
          [style]="{ width: '100%' }"
          [field]="'text'"
        ></p-autoComplete>
      </div>

      <!-- Iconos de Vacaciones -->
      <div class="vacation-icons">
        <div
          class="vacation-option"
          [ngClass]="{
            active: selectedOptionKey == '1' || selectedOptionKey == '3',
            inactive: selectedOptionKey != '1' && selectedOptionKey != '3'
          }"
        >
          <img src="/assets/svg/vacaciones.svg" alt="" />
          <div class="vacation-bottom">
            <span>
              Vacaciones por ley
              <i
                class="pi pi-info-circle"
                (click)="
                  openTooltipModal(
                    'Vacaciones por ley',
                    'Acumulas 1.25 días por mes laborado'
                  )
                "
              ></i>
            </span>
            <small
              [ngClass]="{
                highlight: selectedOptionKey == '1' || selectedOptionKey == '3'
              }"
            >
              Tienes {{ accumulatedDays - usedDaysLaw }} días acumulados
            </small>
          </div>
        </div>

        <div
          class="vacation-option"
          [ngClass]="{
            active: selectedOptionKey == '2' || selectedOptionKey == '3',
            inactive: selectedOptionKey != '2' && selectedOptionKey != '3'
          }"
        >
          <img src="/assets/svg/reloj.svg" alt="" />
          <div class="vacation-bottom">
            <span>
              Bono vacacional
              <i
                class="pi pi-info-circle"
                (click)="
                  openTooltipModal(
                    'Bono vacacional',
                    'Por año laborado, este bono es entregado anualmente según las políticas de la empresa'
                  )
                "
              ></i>
            </span>
            <small
              [ngClass]="{
                highlight: selectedOptionKey == '2' || selectedOptionKey == '3'
              }"
            >
              Tienes {{ accumulatedBonusDays - usedBonusDays }} días acumulados
            </small>
          </div>
        </div>
      </div>

      <!-- Selección de Fechas -->
      <div class="calendar-row">
        <div class="calendar-item">
          <label for="startDate">Inicio de vacaciones</label>
          <p-calendar
            id="startDate"
            [(ngModel)]="startDate"
            [icon]="'pi pi-pencil'"
            [showIcon]="true"
            (ngModelChange)="onStartDateChange($event)"
            [maxDate]="maxStartDate"
            dateFormat="dd/mm/yy"
          ></p-calendar>
        </div>
        <div class="calendar-item">
          <label for="endDate">Fin de vacaciones</label>
          <p-calendar
            id="endDate"
            [(ngModel)]="endDate"
            [icon]="'pi pi-pencil'"
            [showIcon]="true"
            (ngModelChange)="onEndDateChange($event)"
            [minDate]="startDate"
            [maxDate]="maxEndDate"
            dateFormat="dd/mm/yy"
          ></p-calendar>
        </div>
      </div>

      <!-- Mensaje Opcional -->
      <!-- <div class="p-field">
        <label for="message">Escriba un mensaje (Opcional)</label>
        <div class="textarea-container">
          <textarea
            id="message"
            rows="5"
            [(ngModel)]="message"
            placeholder="Escriba su mensaje aquí..."
            maxlength="200"
          ></textarea>
          <small>200/{{ message.length || 0 }}</small>
        </div>
      </div> -->

      <!-- Mensaje del Colaborador -->
      <div class="p-field">
        <label for="messageCollaborator">Mensaje del Colaborador</label>
        <div class="textarea-container">
          <textarea
            id="messageCollaborator"
            rows="5"
            [(ngModel)]="messageCollaborator"
            maxlength="200"
          ></textarea>
        </div>
      </div>

      <div class="p-field" *ngIf="selectedOptionKey == '4'">
        <div class="file-top">
          <label for="currentFile">Documento:</label>
          <button
            type="button"
            pButton
            (click)="documentGenerated ? downloadFile() : onDownload()"
            class="btn-download"
            [disabled]="shouldDisableDownloadButton()"
          >
            <i
              class="pi"
              [ngClass]="documentGenerated ? 'pi-send' : 'pi-download'"
            ></i>
            {{ documentGenerated ? selectedFileName : "Descargar formato" }}
          </button>
        </div>

        <div
          class="file-container"
          [ngClass]="{ 'disabled-container': !documentGenerated }"
          (dragover)="documentGenerated ? onDragOver($event) : null"
          (dragleave)="documentGenerated ? onDragLeave($event) : null"
          (drop)="documentGenerated ? onDrop($event) : null"
        >
          <div
            class="file-preview"
            (click)="documentGenerated ? openFileUpload('pdf') : null"
          >
            <div class="custom-file-display">
              <div class="custom-file-top">
                <i
                  [ngClass]="
                    selectedFileUploadName ? 'pi pi-file-pdf' : 'pi pi-plus-circle'
                  "
                ></i>
                <span>{{
                  selectedFileUploadName ||
                    (documentGenerated
                      ? "Subir un archivo"
                      : "Genere el documento primero")
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <p-fileUpload
          #pdfUploader
          [accept]="'application/pdf'"
          [maxFileSize]="10000000"
          (onSelect)="onChangeFile($event)"
          [style]="{ display: 'none' }"
          [disabled]="!documentGenerated"
        >
        </p-fileUpload>
      </div>
    </div>

    <div class="column">
      <!-- Calendario -->
      <div class="calendar-container">
        <p-calendar
          [(ngModel)]="selectedDates"
          selectionMode="range"
          [readonlyInput]="true"
          inline="true"
          [minDate]="minDate"
          [maxDate]="maxEndDate"
          (onSelect)="onRangeSelect()"
        />
      </div>

      <div class="total-days-container">
        <h3>Total de días: {{ totalDays }} {{ getDayLabel(totalDays) }}</h3>
        <!-- <p>Expira en: {{ endDate | date : "MMMM d, y" }}</p> -->
        <!-- <hr />
  <small>
    Los días no utilizados de hasta {{ transferableDays }}
    {{ getDayLabel(transferableDays) }} se trasladará al siguiente.
  </small> -->
      </div>
    </div>
  </div>

  <div class="row">
    <div class="column">
      <!-- Confirmación -->
      <div class="confirmation">
        <p-checkbox
          [(ngModel)]="confirmationChecked"
          binary="true"
          inputId="confirmation"
          (ngModelChange)="validateForm()"
        />
        <label for="confirmation">
          He revisado detalladamente mi solicitud de vacaciones
        </label>
      </div>

      <!-- Botón de Enviar -->
      <div class="submit-button">
        <button
          pButton
          type="button"
          label="Solicitar"
          [disabled]="isDisabled"
          (click)="onRegister()"
        ></button>
      </div>
    </div>
    <div class="column"></div>
  </div>
</div>
